
import {of as observableOf,  Observable } from 'rxjs';

import {share, map} from 'rxjs/operators';
import {Inject} from "@angular/core";
import { BaseEntity } from "../base/BaseEntity";
import { CrudOperations } from "../interfaces/crudOperations";
import { HttpClient, HttpParams } from "@angular/common/http";
import { IDocumentResult } from "../base/interfaces/IDocumentResult";
import { IQueryResult } from "../base/interfaces/IQueryResult";
import { IPostbackRequest } from '../base/interfaces/ipostback-request';
import { IPostbackResult } from '../base/interfaces/ipostback-result';

export class DocumentBaseService<T extends BaseEntity> implements CrudOperations<T>{
  Filter(filter?: any, sort?: string, sortOrder?: string, page?: number, pageSize?: number): Observable<IQueryResult<T>> {
    let params = new HttpParams();
    if(filter){
      for(var key in filter) {
        var value = filter[key];
        params.append(key,value);
      }
    }
    if(page){
      params.append('page',page.toString());
    }
    if(pageSize){
      params.append('pageSize',pageSize.toString());          
    }
    if(sort){
      params.append('sort',sort);
    }
    if(sortOrder){
      params.append('sortOrder',sortOrder);                    
    }

    return this.http.get<IQueryResult<T>>(`${this.rootUrl}/${this.endpoint}`,{params:params});
  }
    
    /**
     *
     */
    data;
    observable;
    singularEndpoint:string;

     constructor(
        protected http: HttpClient,
        protected rootUrl: string,
        protected endpoint: string,
        protected singular: string = null
    ) {                
        if( singular === null  && this.endpoint.substr(this.endpoint.length-1)==='s'){
            this.singularEndpoint = this.endpoint.substr(0,this.endpoint.length-1);
        }
        else{
            this.singularEndpoint = singular;
        }
    }
  Postback(code: string, model: IPostbackRequest<T>): Observable<IPostbackResult<T>> {
    const params = {};
    params['taskCode'] = code;    
    return this.http.post<IPostbackResult<T>>(`${this.rootUrl}/${this.endpoint}/postback`, model, {params: params});
  }
    New(): Observable<IDocumentResult<T>> {
      return this.http.post<IDocumentResult<T>>(`${this.rootUrl}/${this.endpoint}/create`,null); 
    }    
    Create(model: T): Observable<any> {
        if(!model.id){
          model.id = '00000000-0000-0000-0000-000000000000';
        }        
        return this.http.post<T>(`${this.rootUrl}/${this.endpoint}/${this.singularEndpoint}`,model); 
    }

    Update(model: T): Observable<any> {
        return this.http.put<T>(`${this.rootUrl}/${this.endpoint}/${this.singularEndpoint}`,model);
    }
    Delete(id: string): Observable<any> {
        return this.http.delete(`${this.rootUrl}/${this.endpoint}/${this.singularEndpoint}/${id}`);
    }
    Get(id: string): Observable<IDocumentResult<T>> {
        return this.http.get<IDocumentResult<T>>(`${this.rootUrl}/${this.endpoint}/${this.singularEndpoint}/${id}`);
    }
    GetAll(): Observable<IQueryResult<T>> {
        return this.http.get<IQueryResult<T>>(`${this.rootUrl}/${this.endpoint}`);
    }
    Search(query: string): Observable<IQueryResult<T>> {
        let params = new HttpParams();
        if(query){
          params.append('queryString',query);
        }
        return this.http.get<IQueryResult<T>>(`${this.rootUrl}/${this.endpoint}`,{params:params});
    }    
    GetCached(){
        if (this.data) {
          return observableOf(this.data);
        } else if (this.observable) {
          return this.observable;
        } else {
          this.observable = this.http.get(`${this.rootUrl}/${this.endpoint}`, {
            observe: 'response'
          }).pipe(
          map(response =>  {
            this.observable = null;
            if (response.status === 400) {
              return 'Request failed.';
            } else if (response.status === 200) {
              this.data = response.body;
              return this.data;
            }
          }),
          share(),);
          return this.observable;
        }
      }    
}